import { createRoot } from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

import { SWRConfig } from "swr";
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";
import * as Sentry from "@sentry/react";

const app = (
  <I18nextProvider i18n={i18n}>
    <BrowserRouter>
      <SWRConfig
        value={{
          refreshInterval: 0,
          revalidateOnMount: true,
          revalidateOnFocus: false,
        }}
      >
        <App />
      </SWRConfig>
    </BrowserRouter>
  </I18nextProvider>
);

const isLocalDev =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1" ||
  window.location.hostname === "";

const isDev = import.meta.env.VITE_ENV === "dev";
const isStaging = import.meta.env.VITE_ENV === "staging";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: isLocalDev
    ? []
    : [

        Sentry.consoleLoggingIntegration({ levels: ["log", "error"] }),
      ],
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  enableLogs: !isLocalDev,
  debug: isDev || isStaging,
  environment: isDev ? "development" : "production",
  release: import.meta.env.VITE_SENTRY_RELEASE,
});

const container = document.getElementById("root");
const root = createRoot(container);
root.render(app);

// Hide initial loader once React has mounted
const initialLoader = document.getElementById("initial-loader");
if (initialLoader) {
  // Add hidden class to fade out
  initialLoader.classList.add("hidden");
  // Remove from DOM after transition completes
  setTimeout(() => {
    initialLoader.remove();
  }, 300);
}
